module.exports = __webpack_public_path__ + "img/red_025.cc5c329e.png";